// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const filtersOpenedSelector = (state: ApplicationState) => {
    // console.log(state, "state");
    return state.bunzl.pages.reportOrderFrequency.filtersOpen;
};
export const locationsSelector = (state: ApplicationState) => {
    // console.log(state, "state");
    return state.bunzl.pages.reportOrderFrequency.locationList;
};
export const reportOrderFrequencySelector = (state: ApplicationState) => {
    // console.log(state, "state");
    return state.bunzl.pages.reportOrderFrequency.orderFrequencyReportData;
};
export const reportParametersSelector = (state: ApplicationState) => {
    // console.log(state, "state");
    return state.bunzl.pages.reportOrderFrequency.getReportParams;
};
